<template>
  <v-container>
    <loading-spinner v-if="loading"></loading-spinner>
    <template v-else>
      <v-row>
        <v-col cols="12">
          <v-btn color="performance" @click="goBack" dark>
            Go Back
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <annual-review-user-list :user="detail_user"></annual-review-user-list>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AnnualReviewUserList from "@/components/annualreviews/AnnualReviewUserList";
export default {
  name: "AnnualReviewUserOverview",
  components: {
    AnnualReviewUserList
  },
  data: () => ({
    loading: true
  }),
  watch: {
    profile(val, oldVal) {
      if (val == oldVal) {
        return;
      }
      this.getData();
    }
  },
  computed: {
    detail_user() {
      return this.annual_reviews
        .map(x => x.user)
        .find(x => x.id == this.$route.params.userId);
    },
    ...mapGetters({
      annual_reviews: "annualreview/list",
      overview: "annualreview/overview",
      profile: "profile/profile"
    })
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      if (this._.isEmpty(this.profile) || !this.profile.isManager) {
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("annualreview/getAnnualReviewOverview")
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your annual reviews."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
